var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAthletes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_177_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 0H4.06841C1.82149 0 0 1.82149 0 4.06841V19.9316C0 22.1785 1.82149 24 4.06841 24H19.9316C22.1785 24 24 22.1785 24 19.9316V4.06841C24 1.82149 22.1785 0 19.9316 0Z",
    fill: "#91231F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85661 9.61337C9.19327 11.47 10.4266 12.6701 11.9966 12.6701C13.5666 12.6701 14.7733 11.5 15.1366 9.6167C15.1699 9.4367 15.4766 7.84669 15.4933 7.48002C15.5333 6.59335 15.2133 5.74668 14.5899 5.09667C13.9233 4.4 12.9799 4 11.9966 4C11.0133 4 10.0499 4.40667 9.37994 5.11667C8.76327 5.77001 8.45327 6.61002 8.50327 7.48335C8.52327 7.84669 8.82661 9.43337 8.85994 9.61003L8.85661 9.61337ZM9.86327 5.58001C10.4099 5.00334 11.1866 4.67 11.9966 4.67C12.8066 4.67 13.5666 4.99334 14.1066 5.56001C14.6033 6.07668 14.8566 6.75002 14.8266 7.45335C14.8166 7.69336 14.6133 8.80336 14.4799 9.49337C14.2466 10.7067 13.4733 12.0067 11.9966 12.0067C10.5199 12.0067 9.72327 10.6567 9.51327 9.49337C9.37994 8.80336 9.17994 7.69002 9.16661 7.45002C9.12661 6.76335 9.37327 6.10001 9.86327 5.58001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6233 16.8762C19.4633 15.9429 18.6767 15.2295 17.5 14.9662L11.9967 13.9995L6.48 14.9762C5.34 15.2129 4.53333 15.9462 4.37 16.8962L4 20.0062H20L19.6267 16.8795L19.6233 16.8762ZM4.71 19.3362L5.02667 16.9962C5.16333 16.2029 5.93667 15.7695 6.60667 15.6295L11.9967 14.6762L17.37 15.6195C17.7967 15.7162 18.8033 16.0429 18.9633 16.9762L19.28 19.3362H4.71Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_177_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthletes);
export default __webpack_public_path__ + "static/media/athletes.7b4f7659721b30fcc8ec7351a9c52f5f.svg";
export { ForwardRef as ReactComponent };